/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ConfirmationHeader: {
        id: 'cep.components.sgEndorsementConfirmationPage.ConfirmationHeader',
        defaultMessage: 'Thank you {policyHolder} for updating your Saga {product} Insurance'
    },
    DocumentsInfo: {
        id: 'cep.components.sgEndorsementConfirmationPage.DocumentsInfo',
        defaultMessage: 'Your policy has been changed successfully. Updated policy details will be available within your MySaga online account shortly.'
    },
    BackToMain: {
        id: 'cep.components.sgEndorsementConfirmationPage.BackToMain',
        defaultMessage: 'Back to MySaga'
    },
    TrustpilotHeader: {
        id: 'cep.components.sgEndorsementConfirmationPage.TrustpilotHeader',
        defaultMessage: 'Review us on Trustpilot'
    },
    TrustpilotMessage: {
        id: 'cep.components.sgEndorsementConfirmationPage.TrustpilotMessage',
        defaultMessage: 'We\'d love to hear about your experience with Saga so far. Please leave us a review as all feedback is appreciated.'
    },
    TrustpilotButtonLabel: {
        id: 'cep.components.sgEndorsementConfirmationPage.TrustpilotButtonLabel',
        defaultMessage: 'Leave a review'
    },
    AbilityToPayInfo: {
        id: 'cep.components.sgEndorsementConfirmationPage.AbilityToPayInfo',
        defaultMessage: 'Please let us know if you are unable to make your payments in the future.'
    }
});
